import React from 'react';
import {Skeleton as MuiSkeleton, SxProps, Theme} from '@mui/material';
import {designSystemToken} from '@lightricks/react-design-system';

const DEFAULT_ROUNDED_BORDER_RADIUS = 4;

type SkeletonProps = {
  variant: 'text' | 'rectangular' | 'rounded' | 'circular';
  animation?: 'pulse' | 'wave' | false;
  width: number | string;
  height: number | string;
  backgroundColor?: string;
  borderRadius?: number | string;
  margin?: string | number;
  sx?: SxProps<Theme>;
};

function Skeleton({
  variant,
  animation = 'wave',
  width,
  height,
  backgroundColor,
  borderRadius,
  margin,
  sx,
}: SkeletonProps) {
  return (
    <MuiSkeleton
      variant={variant}
      animation={animation}
      width={width}
      height={height}
      sx={{
        'margin': margin,
        borderRadius,
        '&.MuiSkeleton-wave': {
          background: backgroundColor || designSystemToken('semantic.bg.alpha'),
        },
        '&.MuiSkeleton-wave::after': {
          background:
            'linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.05), transparent)',
        },
        '&.MuiSkeleton-pulse': {
          background: backgroundColor || designSystemToken('semantic.bg.alpha'),
        },
        '&.MuiSkeleton-rounded': {
          borderRadius: borderRadius || DEFAULT_ROUNDED_BORDER_RADIUS,
        },
        ...sx,
      }}
    />
  );
}

export default Skeleton;
